export default "__VITE_ASSET__aeLzYnaP__"